<template>
  <div>
    <oil-form
      :keys='keys'
      :items='report'
      :createForm='true'
      :title="'ОТЧЕТЫ общий'.toUpperCase()"
      :formCallback='formCallback'
    >
      <template v-slot:saveBtn='{input,method}'>
        <v-btn disaled
               @click='method.action'
               color='primary'
               :loading='input.isLoading'
               :disabled='!input.isLoading && !report.Names'
        >
          ЗАГРУЗИТЬ
        </v-btn>
      </template>
      <template v-slot:closeBtn='{method,input}'>

        <v-btn text color='normal'
               @click='method.action'
               :disabled='!input.isLoading && !input.isEdit'
        >
          Назад
        </v-btn>
      </template>
    </oil-form>

    <!--    <embed width="800" height="800" :src="url" type="application/pdf"/>-->

  </div>

</template>
<script>
import report from './setting/report.json'
import { coreApi } from '@/services/core'
import XLSX from 'xlsx'

export default {
  components: {
    OilForm: () => import('@/components/helper/oil.form')
  },
  data: () => ({
    keys: report,
    something: '',
    testDate: '',
    url: '',
    report: {
      Names: '',
      StartDate: '',
      EndDate: ''
    },
    searchModels: {
      company: {
        url: 'company',
        keys: () => import('./setting/company.json'),
        action: (Buyer) => {
          return {
            'Название': Buyer.CompanyName,
            'Договора': Buyer.ContractNumbers,
            'Адрес': Buyer.Address,
            'Расчетный счет': Buyer.AccountNumber,
            'Контактное лицо': Buyer.ContactPerson,
            'Адрес банка': Buyer.BankAddress,
            'Название банка': Buyer.BankName,
            'Директор': Buyer.Manager,
            'Телефон': Buyer.Phone,
            'Статус': Buyer.IsActive ? 'Активный' : 'Неактивный',
            'АКЦИЗ': Buyer.HasPrivelege ? 'С АКЦИЗом' : 'Без АКЦИЗа'
          }
        }
      },
      contract: {
        url: 'contract',
        action: (Contract, status = {
          active: 'Активный',
          notsigned: 'Неподписанный',
          special: 'Особый',
          inactive: 'Неактивный'
        }) => {
          const {CompanyName, TaxNo} = Contract.Buyer
          const {Number, StartDate,Status} = Contract
          return {
            'Покупатель': CompanyName,
            'Договор': Number,
            'ИНН': TaxNo,
            'Дата': StartDate,
            'Статус': status[Status],
          }
        }
      },
        waybill: {
          url: 'waybill',
          action: (Waybill, status = {
            active: 'Активный',
            return: 'Возврат',
            notsigned: 'Неподписанный',
            special: 'Особый',
            inactive: 'Неактивный'
          }) => {
            const { CompanyName, TaxNo } = Waybill.Buyer
            const { Number } = Waybill.Contract
            return {
              'Покупатель': CompanyName,
              'Договор': Waybill.Contract.Number,
              'ИНН': TaxNo,
              'ТТН': `${Number}-${Waybill.Number}`,
              'Дата ТТН': Waybill.ShipmentDate,
              'Статус ТТН': status[Waybill.Status]
            }
          }
        },
        empowerment: {
          url: 'empowerment',
          action: (Empowerment, status = {
            active: 'Активный',
            notsigned: 'Неподписанный',
            special: 'Особый',
            inactive: 'Неактивный'
          }) => {
            const { CompanyName, TaxNo } = Empowerment.Company
            return {
              'Покупатель': CompanyName,
              'ИНН': TaxNo,
              'Доверенность': Empowerment.Number,
              'Статус ТТН': status[Empowerment.Status]
            }
          }
        },
        act: {
          url: 'act',
          action: (act) => {
            const { CompanyName, TaxNo } = act.Buyer
            const { Number } = act.Contract
            return {
              'Покупатель': CompanyName,
              'Договор': Number,
              'ИНН': TaxNo,
              'Акт сверки': act.Number
            }
          }
        },
        report: {
          url: 'WaybillFormInvoice',
          action: (value, status = {
            active: 'Активный',
            notsigned: 'Неподписанный',
            special: 'Особый',
            inactive: 'Неактивный'
          }) => {
            return {
              'Дата': value.WaybillDate,
              'Заказчик плательщик': value.BuyerName,
              'Договор': value.ContractDate,
              'Приложение': value.AppendixDate,
              'Номер ТТН': value.WaybillNumber,
              'Наименование товара, тары, операции': value.ProductName,
              'Плотность': value.Density,
              'Количество в тоннах': value.Tons,
              'Количество в литрах': value.Liter,
              'Цена': value.Price, //Density
              'Акциз/ставка': value.Excise,
              'Акциз/сумма': value.TotalExcise,
              'Стоимость поставки': value.waybillModel.NetTotal,
              'НДС/ставка': value.VAT,
              'НДС/сумма': value.TotalVAT,
              'Стоимость поставки с учетом НДС': value.Total,
              'Доверенность': value.EmpowermentNumber,
              'Счет фактура': value.WaybillNumber,
              'Статус ТТН': status[value.Status]
            }
          }
        }
      }
    }),

  methods: {

    async formCallback({ StartDate, EndDate }) {

      const name = this.report.Names
      const schema = this.searchModels[name]

      const params = {
        name: schema.url,
        start: StartDate,
        end: EndDate
      }

      const response = await coreApi.get('report', { params })

      if (!response.data || response.data?.length === 0) {
        alert('За выбранный период не было найдено записей.')
        return
      }

      try {

        const result = [
          {},
          ...response.data.map(value => {
              return {
                ...schema.action(value)
              }
            }
          )
        ]

        const data = XLSX.utils.json_to_sheet(result)
        const wb = XLSX.utils.book_new()

        XLSX.utils.book_append_sheet(wb, data, 'Счет фактуры')
        XLSX.writeFile(wb, 'Счет фактуры.xlsx')

      } catch (e) {
        console.log(e.message)
      }

    }
    // fnExcelReport() {
    //   var tab_text = '<table style=\'text-align: center\'><tr>'
    //   var textRange
    //   var j = 0
    //   var tab = document.getElementById('headerTable') // id of table
    //
    //   for (j = 0; j < tab.rows.length; j++) {
    //     tab_text = tab_text + tab.rows[j].innerHTML + '</tr>'
    //   }
    //
    //   tab_text = tab_text + '</table>'
    //   tab_text = tab_text.replace(/<A[^>]*>|<\/A>/g, '')//remove if u want links in your table
    //   tab_text = tab_text.replace(/<img[^>]*>/gi, '') // remove if u want images in your table
    //   tab_text = tab_text.replace(/<input[^>]*>|<\/input>/gi, '') // reomves input params
    //
    //   var ua = window.navigator.userAgent
    //   var msie = ua.indexOf('MSIE ')
    //
    //   if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))      // If Internet Explorer
    //   {
    //     txtArea1.document.open('txt/html', 'replace')
    //     txtArea1.document.write(tab_text)
    //     txtArea1.document.close()
    //     txtArea1.focus()
    //     var sa = txtArea1.document.execCommand('SaveAs', true, 'Say Thanks to Sumit.xls')
    //   } else                 //other browser not tested on IE 11
    //     var sa = window.open('data:application/vnd.ms-excel,' + encodeURIComponent(tab_text))
    //   console.log(tab_text)
    //   return (sa)
    // }
  }
}
</script>